import React from 'react';
import { useParams } from 'react-router-dom';

const ActivateTestPage = () => {
  const { token } = useParams();
  
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <h1>Activate Account Test Page</h1>
      <p>Token from URL: {token || 'No token found'}</p>
      <p>This is a test page to verify the routing is working.</p>
      
      <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6' }}>
        <h3>Debug Info:</h3>
        <p>Current URL: {window.location.href}</p>
        <p>Current pathname: {window.location.pathname}</p>
      </div>
    </div>
  );
};

export default ActivateTestPage;
